import { combineReducers } from 'redux';
import { reducer as oidcReducer } from 'redux-oidc';
import { announcementAudio } from './announcementAudio';
import { announcements } from './announcements';
import { audioPreview } from './audioPreview';
import { roadConditions } from './roadConditions';
import { roadSpecialEvents } from './specialEvents';
import { roadXmlFiles } from './xmlFiles';


const rootReducer = combineReducers({
  oidc: oidcReducer,
  roadConditions,
  roadSpecialEvents,
  roadXmlFiles,
  audioPreview,
  announcements,
  announcementAudio
});

export default rootReducer;
